/**
 * #199: the two browser file chores that were copied from component to component — four image
 * previews read through a `FileReader`, three downloads through a temporary link.
 */

/**
 * Reads a blob as a `data:` URL, e.g. for an `<img [src]>` preview, and hands it to `onLoad`
 * once read. A missing blob (no image uploaded yet) is not an error: nothing happens.
 */
export function readAsDataUrl(blob: Blob | null | undefined, onLoad: (dataUrl: string) => void): void {
  if (!blob) {
    return;
  }
  const reader = new FileReader();
  reader.addEventListener('load', () => onLoad(reader.result as string));
  reader.readAsDataURL(blob);
}

/** Offers a blob to the user as a download named `fileName`, through the browser's own UI. */
export function saveBlob(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(objectUrl);
}
